import React, { useState } from "react";
import { RefreshCw, CheckCircle2, CloudOff } from "lucide-react";
import { toast } from "sonner";
import { offlineManager, useOfflineStatus } from "../lib/offlineManager";

// Indicateur cliquable du nombre de saisies en attente de synchronisation.
const SyncStatusBadge = () => {
  const { isOffline, syncStats } = useOfflineStatus();
  const pending = syncStats?.pending || 0;
  const [syncing, setSyncing] = useState(false);

  if (pending === 0) return null;

  const forceSync = async () => {
    if (syncing) return;
    if (isOffline) {
      toast.info("Hors-ligne — la synchronisation démarrera automatiquement au retour du réseau.");
      return;
    }
    setSyncing(true);
    try {
      await offlineManager.triggerSync();
    } finally {
      setTimeout(() => setSyncing(false), 800);
    }
  };

  return (
    <button
      onClick={forceSync}
      disabled={syncing}
      title={isOffline ? "En attente du réseau" : "Cliquez pour synchroniser maintenant"}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold transition-colors ${
        isOffline
          ? "bg-amber-100 text-amber-700 hover:bg-amber-200"
          : "bg-blue-100 text-blue-700 hover:bg-blue-200"
      }`}
      data-testid="sync-status-badge"
    >
      {syncing ? (
        <RefreshCw className="w-3.5 h-3.5 animate-spin" />
      ) : isOffline ? (
        <CloudOff className="w-3.5 h-3.5" />
      ) : (
        <RefreshCw className="w-3.5 h-3.5" />
      )}
      <span data-testid="sync-pending-count">{pending}</span>
      <span className="hidden sm:inline">{pending > 1 ? "saisies en attente" : "saisie en attente"}</span>
    </button>
  );
};

export default SyncStatusBadge;
